var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNewQrCode = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46167 4.84628H6.38474C5.53508 4.84628 4.84628 5.53508 4.84628 6.38474V9.46167C4.84628 10.3113 5.53508 11.0001 6.38474 11.0001H9.46167C10.3113 11.0001 11.0001 10.3113 11.0001 9.46167V6.38474C11.0001 5.53508 10.3113 4.84628 9.46167 4.84628Z",
    stroke: "#1C70E9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84615 1H2.53846C2.13044 1 1.73912 1.16209 1.4506 1.4506C1.16209 1.73912 1 2.13044 1 2.53846V4.84615",
    stroke: "#1C70E9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1537 1H19.4614C19.8694 1 20.2607 1.16209 20.5493 1.4506C20.8378 1.73912 20.9999 2.13044 20.9999 2.53846V4.84615",
    stroke: "#1C70E9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84615 20.9999H2.53846C2.13044 20.9999 1.73912 20.8378 1.4506 20.5493C1.16209 20.2607 1 19.8694 1 19.4614V17.1537",
    stroke: "#1C70E9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1537 20.9999H19.4614C19.8694 20.9999 20.2607 20.8378 20.5493 20.5493C20.8378 20.2607 20.9999 19.8694 20.9999 19.4614V17.1537",
    stroke: "#1C70E9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84628 14.8463V17.154H7.15398",
    stroke: "#1C70E9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.154V14.8463H8.69226",
    stroke: "#1C70E9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.154 7.15397H14.8463V4.84628",
    stroke: "#1C70E9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.154 12.5385V10.2308H14.8463",
    stroke: "#1C70E9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8463 14.8463V17.154H17.154",
    stroke: "#1C70E9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewQrCode, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/newQrCode.6da40255.svg";
export { ForwardRef as ReactComponent };